/**
 * Centralized route definitions.
 *
 * ROUTES  - absolute paths / builder functions used in navigate() and <Link to=...>
 * PATHS   - relative path segments used in the React Router config (router.tsx)
 */ export const ROUTES = {
    home: '/',
    login: '/login',
    app: '/app',
    // Today — the operator's start-here screen
    today: '/app/today',
    // Cars
    carDetail: (vin)=>`/app/cars/${vin}`,
    // Unified vehicle lifecycle (Inventory)
    inventory: '/app/vehicles',
    vehicleDetail: (id)=>`/app/vehicles/${id}`,
    // Customers
    customers: '/app/customers',
    customerDetail: (id)=>`/app/customers/${id}`,
    // Prospects
    prospects: '/app/prospects',
    prospectDetail: (id)=>`/app/prospects/${id}`,
    // Auction
    auction: '/app/auction',
    auctionBrowser: '/app/auction-browser',
    automationBrowser: '/app/automation-browser',
    auctionVehicle: (source, slug)=>`/app/auction/${source}/${slug}`,
    // Legacy importing path — redirects to the cost tracker
    importing: '/app/importing',
    // Cost Tracker
    costTracker: '/app/cost-tracker',
    // US transport moves (port → shop)
    shipments: '/app/shipments',
    // US customs entries (through the shop's customs broker)
    customs: '/app/customs',
    customsEntry: (id)=>`/app/customs/${id}`,
    customsOnboarding: '/app/customs/onboarding',
    customsIsf: (id)=>`/app/customs/${id}/isf`,
    // Custom Orders (primary product). The old /find-me-buys routes redirect.
    orders: '/app/orders',
    myShop: '/app/my-shop',
    orderDetail: (id)=>`/app/orders/${id}`,
    // Legacy alias paths — kept so old links don't 404. Router redirects them
    // to the /orders equivalents.
    findMeBuys: '/app/find-me-buys',
    customOrderDetail: (id)=>`/app/find-me-buys/orders/${id}`,
    // Outbox — customer emails waiting for review (draft-first). The old full
    // inbox page is gone; /app/inbox redirects here.
    outbox: '/app/outbox',
    // Admin
    admin: '/app/admin',
    team: '/app/team',
    invite: (token)=>`/invite/${token}`,
    forgotPassword: '/forgot-password',
    // Self sign-up, its emailed confirmation link, and paying before anything else.
    signup: '/signup',
    verifyEmail: (token)=>`/verify-email/${token}`,
    payToStart: '/app/start',
    settings: '/app/settings',
    // The in-app Help guide; sections are anchors (/app/help#costs).
    help: '/app/help',
    // The welcome flow (first sign-in; Help → Restart setup).
    welcome: '/app/welcome',
    /** Settings → Auction logins (where the Ninja login lives). */ auctionLogins: '/app/settings#auction-logins'
};
/** Relative path segments for the React Router `path:` config entries. */ export const PATHS = {
    app: '/app',
    today: 'today',
    carDetail: 'cars/:vin',
    inventory: 'vehicles',
    vehicleDetail: 'vehicles/:id',
    customers: 'customers',
    customerDetail: 'customers/:id',
    prospects: 'prospects',
    prospectDetail: 'prospects/:id',
    auction: 'auction',
    auctionBrowser: 'auction-browser',
    automationBrowser: 'automation-browser',
    auctionVehicle: 'auction/:source/:slug',
    importing: 'importing',
    shipments: 'shipments',
    customs: 'customs',
    customsEntry: 'customs/:id',
    customsOnboarding: 'customs/onboarding',
    customsIsf: 'customs/:id/isf',
    costTracker: 'cost-tracker',
    orders: 'orders',
    myShop: 'my-shop',
    orderDetail: 'orders/:id',
    findMeBuys: 'find-me-buys',
    findMeBuysResults: 'find-me-buys/:id',
    customOrderDetail: 'find-me-buys/orders/:id',
    outbox: 'outbox',
    // Legacy: the removed Inbox page — redirected to the Outbox.
    inbox: 'inbox',
    inboxThread: 'inbox/:threadId',
    admin: 'admin',
    team: 'team',
    settings: 'settings',
    help: 'help',
    welcome: 'welcome'
};
